import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API, timeout: 15000 });

export const fetchCaseStudies = () =>
    api.get("/case-studies").then((r) => r.data);

export const fetchCaseStudy = (slug) =>
    api.get(`/case-studies/${slug}`).then((r) => r.data);

export const submitEnquiry = (payload) =>
    api.post("/enquiries", payload).then((r) => r.data);
